import Vue from 'vue';
import Vuex from 'vuex';
import en from '@/language/en-US'
import zh from '@/language/zh-CN'
Vue.use(Vuex);

const state={
    count: 3,
    langs: {
        en,zh
    },
    lang: {}

}



const mutations={                  
    lang(state,language){
        localStorage.localang=language
        state.lang=state.langs[language]; 
    }
}

export default new Vuex.Store({
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/vuex/store.js